import { delegateInit } from './BaseShape';
import { Rectangle } from './Rectangle';

const ENTITY_FIELD_NAME = 'ObjectProperty';

export default delegateInit(Rectangle, ENTITY_FIELD_NAME);
